<template>
  <v-dialog width="1000px" v-model="localValue.isVisible">
    <Loader v-model="loading" />
    <v-card>
      <v-toolbar color="primary" dark>
        <v-btn icon dark @click="localValue.isVisible = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Descuento de articulo</v-toolbar-title>
      </v-toolbar>
      <v-container fluid>
        <v-row>
          <v-col>
            <v-card>
              <v-card-title> Informacion </v-card-title>
              <v-card-text>
                <v-container fluid>
                  <v-row>
                    <v-col>
                      <v-text-field
                        outlined
                        readonly
                        label="Cantidad"
                        :value="localValue.posdet.dblCantidad"
                      />
                    </v-col>
                    <v-col>
                      <v-text-field
                        outlined
                        readonly
                        label="Nombre"
                        :value="localValue.posdet.strNombre"
                      />
                    </v-col>
                    <v-col>
                      <v-text-field
                        outlined
                        readonly
                        label="Precio"
                        :value="toMoney(localValue.posdet.dblPU)"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        outlined
                        readonly
                        label="IVA"
                        :value="toPercent(localValue.posdet.dblPorcentajeIVA / 100)"
                      />
                    </v-col>
                    <v-col>
                      <v-text-field
                        outlined
                        readonly
                        label="Subtotal"
                        :value="toMoney(localValue.posdet.dblTotal)"
                      />
                    </v-col>
                    <v-col>
                      <v-text-field
                        outlined
                        readonly
                        label="Descuento"
                        :value="toMoney(descuento)"
                      />
                    </v-col>
                    <v-col>
                      <v-text-field
                        outlined
                        readonly
                        label="Total"
                        :value="toMoney(total)"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card>
              <v-card-title> Autorizacion </v-card-title>
              <v-card-text>
                <v-container fluid>
                  <v-row>
                    <v-col>
                      <v-text-field
                        dense
                        v-model="usuario.usuario"
                        :rules="[() => !!usuario.usuario || 'Llene este campo']"
                        append-icon="mdi-account"
                        label="Usuario"
                        outlined
                        required
                      >
                      </v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        dense
                        v-model="usuario.password"
                        :rules="[() => !!usuario.password || 'Llene este campo']"
                        append-icon="mdi-shield-lock"
                        label="Password"
                        type="password"
                        outlined
                        required
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-select
                        dense
                        :items="descuentos"
                        outlined
                        ref="motivo"
                        item-text="strNombre"
                        item-value="intPOSMotivoDescuento"
                        label="Motivo"
                        v-model="localValue.motivo"
                      >
                      </v-select>
                    </v-col>
                    <v-col>
                      <v-text-field
                        dense
                        ref="comentario"
                        v-model="localValue.comentario"
                        label="Comentario"
                        outlined
                      >
                      </v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        dense
                        ref="porcentaje"
                        min="0"
                        max="100"
                        type="number"
                        v-model="localValue.porcentaje"
                        label="Porcentaje"
                        outlined
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn color="success" dark block @click="aceptar()"> Guardar </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
var numeral = require("numeral");
var math = require("mathjs");
import Loader from "../components/Loader.vue";
import { Usuario, Session, Toast, ErrorWeb } from "../controllers/DataController.js";
import { POSDetFunctions } from "../controllers/POSController";

export default {
  props: {
    descuentos: {
      type: Array,
      default: () => [],
    },
    value: {
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      usuario: new Usuario(),
      localValue: this.value,
      detFunctions: new POSDetFunctions(),
      session: new Session(),
    };
  },
  components: {
    Loader,
  },
  computed: {
    descuento() {
      if (this.localValue.porcentaje > 0) {
        let x = math.chain(this.localValue.porcentaje).divide(100).done();
        return math.chain(this.localValue.posdet.dblTotal).multiply(x).done();
      } else {
        return 0;
      }
    },
    total() {
      if (this.localValue.posdet.dblTotal != null) {
        return math
          .chain(this.localValue.posdet.dblTotal)
          .subtract(this.descuento)
          .done();
      } else {
        return 0;
      }
    },
  },
  methods: {
    async aceptar() {
      this.loading = true;
      try {
        if (
          this.localValue.motivo == null ||
          this.localValue.motivo == "" ||
          this.localValue.motivo == 0
        ) {
          this.$refs.motivo.focus();
          throw "Seleccione un motivo";
        }
        if (this.localValue.comentario == null || this.localValue.comentario == "") {
          this.$refs.comentario.focus();
          throw "Agregue un comentario";
        }

        if (
          this.localValue.porcentaje == 0 ||
          this.localValue.porcentaje == null ||
          this.localValue.porcentaje == ""
        ) {
          this.$refs.porcentaje.focus();
          throw "Agregue un porcentaje";
        }
        //*Validamos usuario
        const validacion = await this.usuario.validate_descuento();
        if (!validacion) throw "No se pudo validar el usuario, no tiene permisos";

        this.localValue.posdet.intPOSMotivoDescuento = this.localValue.motivo;
        this.localValue.posdet.dblPorcentajeDescuento = this.localValue.porcentaje;
        this.localValue.posdet.dblImporteDescuento = this.descuento;
        this.localValue.posdet.strUsuarioMod = this.session.usuario;
        this.localValue.posdet.strReferenciaDescuento = this.comentario;
        this.localValue.posdet.strClaveDescuento = "DESCUENTO";
        this.localValue.posdet.intTipoDescuento = 1;
        const POSEnc = await this.detFunctions.descuento(this.localValue.posdet);
        //*Limpiamos
        this.localValue.isVisible = false;
        this.localValue.porcentaje = 0;
        this.usuario = new Usuario();
        this.localValue.comentario = "";
        this.localValue.motivo = 0;
        this.$emit("guardar", POSEnc);
      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      } finally {
        this.loading = false;
      }
      //this.$emit("guardar");
    },
    toMoney(value) {
      return numeral(value).format("$0,0.00");
    },
    toPercent(value) {
      return numeral(value).format("0.00%");
    },
  },
  watch: {
    localValue(newValue) {
      this.$emit("input", newValue);
    },
    value(newValue) {
      this.localValue = newValue;
    },
  },
};
</script>

<style></style>
